<template>
    <div class="home_area">
        
        <!--<div class="open_event_filter_outer_div" :style="{'height':$root.filter_btn_postion_fix.outer_height}">
            <div class="open_event_filter_inner_div" :style="{'max-height':$root.filter_btn_postion_fix.inner_height}">
                <div class="open_event_filter_content_div">
                    <div class="open_event_filter_div">
                        <div class="open_event_filter_div_icon" @click="openEventFilter()"></div>
                    </div>
                </div>
            </div>
        </div>--> <!-- open_event_filter_outer_div end -->
        <div class="open_event_filter_sticky_icon_outer" :style="{'height':$root.filter_btn_postion_fix.outer_height}">
            <div class="open_event_filter_sticky_icon" :style="{'top':$root.filter_btn_postion_fix.caculate_sticky_top}" @click="openEventFilter()"></div>
        </div>

        <div class="full_content_area home_top_area_div">
            <a name="home_top" class="a_shortcut_fix" />

            <div class="banner_div max_width">
                <!-- banner start -->
                <div class="banner_area" v-if="banners.length>0">

                    <div class="banner_area_slide_area display_desktop isInherit" ref="slide" v-if="banners.length>0">
                        <div class="banner_area_slide_outer_div" v-for="(banner,index) in banners" :key="index">
                            <div class="banner_area_slide" :style="{backgroundImage: 'url(\'' + banner.src + '\')'}">
                                <!--<img :src="banner.src" align="absmiddle" class="banner_area_slide_src" />-->
                            </div>
                        </div>
                    </div>

                    <div class="banner_area_slide_area display_responsive isInherit" ref="slide_resp" v-if="banners.length>0">
                        <div class="banner_area_slide_outer_div" v-for="(banner,index) in banners" :key="index">
                            <div class="banner_area_slide" :style="{backgroundImage: 'url(\'' + banner.src_resp + '\')'}">
                                <!--<img :src="banner.src_resp" align="absmiddle" class="banner_area_slide_src" />-->
                            </div>
                        </div>
                    </div>

                </div>
                <!-- banner end -->
            </div>
        </div>
        <!-- home_top_area_div end -->

        <div class="full_content_area home_content_area_div">


            <div class="home_content_area max_width">

                <transition name="slide-up">
                    <div class="event_filter_div_area" :style="{'height':$root.full_screen_height.eventfilter_height_fix}" v-if="$root.info.showEventFilter">

                        <div class="event_filter_div_layer">
                            <div class="event_filter_div">

                                <div class="filter_top_div">
                                    <div class="fliter_close_icon" @click="closeEventFilter()"></div>
                                </div>
                                <div class="filter_header_div">
                                    {{label['home_event_filter_title_text']}}
                                </div>
                                <div class="filter_body_div">

                                    <div class="filter_data_tag_div" ref="filter_data_tag_div_1">
                                        <div class="tag_title_div">
                                            {{label['home_event_filter_text_mall']}}
                                        </div>
                                        <div class="tag_filter_div">

                                            <div class="option_filter">

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.mall.length <= 0 }"
                                                     @click="eventFilterTagSelect('mall','all')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_All']}}
                                                    </div>
                                                </div>

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.mall.indexOf(mall.mallCode) >= 0 }"
                                                     v-for="(mall,index) in filter_options.mall"
                                                     :key="'mall'+index"
                                                     @click="eventFilterTagSelect('mall',mall.mallCode)">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{mall.mallName}}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div class="tag_filter_div_arrow_div">

                                        </div>
                                    </div> <!-- mall filter_data_tag_div end -->

                                    <div class="filter_data_tag_div" ref="filter_data_tag_div_2">
                                        <div class="tag_title_div">
                                            {{label['home_event_filter_text_Category']}}
                                        </div>
                                        <div class="tag_filter_div">

                                            <div class="option_filter">

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.category.length <= 0 }"
                                                     @click="eventFilterTagSelect('category','all')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_All']}}
                                                    </div>
                                                </div>

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.category.indexOf(category.categoryCode) >= 0 }"
                                                     v-for="(category,index) in filter_options.category"
                                                     :key="'category'+index"
                                                     @click="eventFilterTagSelect('category',category.categoryCode)">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{category.categoryName}}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div class="tag_filter_div_arrow_div down">
                                            <div class="arrow_down" @click="TagFilterArrowClick($event, 'down')"></div>
                                            <div class="arrow_up" @click="TagFilterArrowClick($event, 'up')"></div>
                                        </div>
                                    </div> <!-- category filter_data_tag_div end -->

                                    <div class="filter_data_tag_div" ref="filter_data_tag_div_3">
                                        <div class="tag_title_div">
                                            {{label['home_event_filter_text_EventType']}}
                                        </div>
                                        <div class="tag_filter_div">

                                            <div class="option_filter">

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.type.length <= 0 }"
                                                     @click="eventFilterTagSelect('type','all')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_All']}}
                                                    </div>
                                                </div>

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.type.indexOf(type.typeCode) >= 0 }"
                                                     v-for="(type,index) in filter_options.type"
                                                     :key="'type'+index"
                                                     @click="eventFilterTagSelect('type',type.typeCode)">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{type.typeName}}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div> <!-- event type filter_data_tag_div end -->

                                    <div class="filter_data_tag_div" ref="filter_data_tag_div_4">
                                        <div class="tag_title_div">
                                            {{label['home_event_filter_text_Date']}}
                                        </div>
                                        <div class="tag_filter_div">

                                            <div class="option_filter">

                                                <div class="option_tag radio_tag"
                                                     :class="{ selected: $root.filter_search.date.filter_type == 'today' }"
                                                     @click="eventFilterTagSelect('date','today')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_Date_today']}}
                                                    </div>
                                                </div>

                                                <div class="option_tag radio_tag"
                                                     :class="{ selected: $root.filter_search.date.filter_type == '7days' }"
                                                     @click="eventFilterTagSelect('date','7days')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_Date_Next7days']}}
                                                    </div>
                                                </div>

                                                <div class="option_tag radio_tag"
                                                     :class="{ selected: $root.filter_search.date.filter_type == '30days' }"
                                                     @click="eventFilterTagSelect('date','30days')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_Date_Next30days']}}
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="option_filter">

                                                <div class="option_tag radio_tag"
                                                     :class="{ selected: $root.filter_search.date.filter_type == 'range' }"
                                                     @click="eventFilterTagSelect('date','range')">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_Date_DateRange']}}
                                                    </div>
                                                </div>

                                                <div class="option_tag date_range_select" id="event_filter_date_range_select_div">

                                                    <div class="date_range_input_div" id="event_filter_date_from_div" @click="eventFilterDatePickerOpen('from')" :class="{ disable: $root.filter_search.date.filter_type != 'range' }">
                                                        <div class="date_range_input_text">
                                                            <input type="hidden" id="event_filter_date_from" class="event_date_filter_text" :value="$root.filter_search.date.date_from" />
                                                            <div id="event_filter_date_from_text" class="event_date_filter_text_display">{{$root.filter_search.date.date_from_display}}</div>
                                                        </div>
                                                        <div class="date_range_input_icon" id="event_filter_date_from_icon"></div>
                                                    </div>
                                                    <div class="date_range_middle_text_div">
                                                        {{label['home_event_filter_text_Date_to']}}
                                                    </div>
                                                    <div class="date_range_input_div" id="event_filter_date_to_div" @click="eventFilterDatePickerOpen('to')" :class="{ disable: $root.filter_search.date.filter_type != 'range' }">
                                                        <div class="date_range_input_text">
                                                            <input type="hidden" id="event_filter_date_to" class="event_date_filter_text" :value="$root.filter_search.date.date_to" />
                                                            <div id="event_filter_date_to_text" class="event_date_filter_text_display">{{$root.filter_search.date.date_to_display}}</div>
                                                        </div>
                                                        <div class="date_range_input_icon" id="event_filter_date_to_icon"></div>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    </div> <!-- date filter_data_tag_div end -->

                                    <div class="filter_data_tag_div" ref="filter_data_tag_div_5">
                                        <div class="tag_title_div">
                                            {{label['home_event_filter_text_Price']}}
                                        </div>
                                        <div class="tag_filter_div">

                                            <div class="option_filter">

                                                <div class="option_tag checkbox_tag"
                                                     :class="{ selected: $root.filter_search.price != -1 }"
                                                     @click="eventFilterTagSelect('price',0)">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{label['home_event_filter_text_Price_FreeOfCharge']}}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div> <!-- price filter_data_tag_div end -->

                                    <div class="filter_data_tag_div" ref="filter_data_tag_div_6">
                                        <div class="tag_title_div">
                                            {{label['home_event_filter_text_Lauguage']}}
                                        </div>
                                        <div class="tag_filter_div">

                                            <div class="option_filter">

                                                <div class="option_tag select_tag"
                                                     :class="{ selected: $root.filter_search.language.indexOf(language.languageCode) >= 0 }"
                                                     v-for="(language,index) in filter_options.language"
                                                     :key="'language'+index"
                                                     @click="eventFilterTagSelect('language',language.languageCode)">
                                                    <div class="option_tag_icon"></div>
                                                    <div class="option_tag_text">
                                                        {{language.languageName}}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div> <!-- langauge filter_data_tag_div end -->


                                </div> <!-- filter_body_div end -->

                                <div class="filter_search_div">
                                    <div class="reset_all_div">
                                        <div class="reset_all_btn" @click="eventFilterResetClick()">
                                            {{label['home_event_filter_text_ResetAll']}}
                                        </div>
                                    </div>
                                    <div class="filter_submit_div" @click="eventFilterSubmitClick()">
                                        {{label['home_event_filter_text_ShowResults']}}
                                    </div>
                                </div> <!-- filter_search_div end -->

                            </div> <!-- event_filter_div end -->
                        </div> <!-- event_filter_div_layer end -->

                    </div> <!-- event_filter_div_area end -->
                </transition>

                <div class="event_list_div_area" id="event_list_div_area">

                    <div class="event_filter_search_tag_display" v-if="checkFilterSearchDisplay()">

                        <div class="filter_tag"
                             v-for="(tag,index) in $root.filter_search_current.mall"
                             :key="'fsm'+index"
                             >
                            <div class="filter_text" v-html="filterSearchTagDisplayText('mall',tag)"></div>
                            <div class="remove_icon" @click="filterSearchTagRemove('mall',tag)"></div>
                        </div>

                        <div class="filter_tag"
                             v-for="(tag,index) in $root.filter_search_current.category"
                             :key="'fsc'+index"
                             >
                            <div class="filter_text" v-html="filterSearchTagDisplayText('category',tag)"></div>
                            <div class="remove_icon" @click="filterSearchTagRemove('category',tag)"></div>
                        </div>

                        <div class="filter_tag"
                             v-for="(tag,index) in $root.filter_search_current.type"
                             :key="'fst'+index"
                             >
                            <div class="filter_text" v-html="filterSearchTagDisplayText('type',tag)"></div>
                            <div class="remove_icon" @click="filterSearchTagRemove('type',tag)"></div>
                        </div>

                        <div class="filter_tag" v-if="$root.filter_search_current.price >= 0">
                            <div class="filter_text" v-html="filterSearchTagDisplayText('price',$root.filter_search_current.price)"></div>
                            <div class="remove_icon" @click="filterSearchTagRemove('price',0)"></div>
                        </div>

                         <div class="filter_tag" v-if="$root.filter_search_current.date.filter_type != ''">
                            <div class="filter_text" v-html="filterSearchTagDisplayText('date',$root.filter_search_current.date.filter_type)"></div>
                            <div class="remove_icon" @click="filterSearchTagRemove('date',$root.filter_search_current.date.filter_type)"></div>
                        </div>

                        <div class="filter_tag"
                             v-for="(tag,index) in $root.filter_search_current.language"
                             :key="'fsl'+index"
                             >
                            <div class="filter_text" v-html="filterSearchTagDisplayText('language',tag)"></div>
                            <div class="remove_icon" @click="filterSearchTagRemove('language',tag)"></div>
                        </div>

                    </div>
                    
                    <div class="event_list_title_div" v-if="$root.eventTitleFilter.searchText.length <= 0">
                        {{label['home_event_list_title_text']}}
                    </div>
                    <div class="event_list_title_div search_result_title" v-if="$root.eventTitleFilter.searchText.length > 0">
                        <div class="search_result_title">
                            {{($root.event_list.total >= 0 ? $root.event_list.total+"" : "-")}} {{label['home_event_filter_text_event_title_filter_result']}} "{{$root.eventTitleFilter.searchText}}"
                        </div>
                        <div class="event_title_filter_close_icon" @click="$root.eventTitleFilterClear();"></div>
                    </div>

                    <div class="event_list_div" v-if="$root.event_list.list.length <= 0 && !$root.event_list.loading">
                        <div class="event_list_div_text">
                            {{label['home_event_list_text_no_event']}}
                        </div>
                    </div>

                    <transition name="slide-down">
                        <div class="event_list_div" v-if="$root.event_list.list.length > 0">

                            <div class="event_list_tag"
                                 v-for="(event,index) in $root.event_list.list"
                                 :key="'event'+index"
                                 @click="$root.goEventDetailsPage(event)">
                                <div class="event_list_area">
                                    <div class="image_outer_div">
                                        <div class="image_inner_div">
                                            <div class="date_over_layer" :class="{ layer1: $root.checkEventIsExpired(event) == 1, layer2: $root.checkEventIsExpired(event) == 2, 'en': $root.info.lang == 'en', 'tc': $root.info.lang == 'tc', 'sc': $root.info.lang == 'sc' }" v-if="$root.checkEventIsExpired(event) == 1 || $root.checkEventIsExpired(event) == 2"></div>
                                            <img :src="event.eventImages[0]" align="absmiddle" />
                                        </div>
                                    </div>
                                    <div class="date_div" v-html="EventListDateDisplay(event)"></div>
                                    <div class="title_div" v-if="$root.checkEventIsExpired(event) == 0 || $root.checkEventIsExpired(event) == 2">
                                        {{event.eventTitle}}
                                    </div>
                                    <div class="title_div" v-if="$root.checkEventIsExpired(event) == 1">
                                        {{label['event_details_text_enrolment_date_is_over_event_title']}}{{event.eventTitle}}
                                    </div>
                                    <div class="location_div" v-if="event.location.length > 0">
                                        <div class="location_icon"></div>
                                        <div class="location_text" v-html="$root.selectEventLocationDisplay(event.location)"></div>
                                    </div>
                                    <div class="status_div" v-if="$root.checkEventStatusDisplayText(event) != ''">
                                        <div class="status_box_div">
                                            <div class="status_text">{{$root.checkEventStatusDisplayText(event)}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div> <!-- event_list_tag end -->

                        </div>
                    </transition>
                </div> <!-- event_list_div_area end -->

            </div> <!-- home_content_area end -->

        </div>
        <!-- home_content_area_div end -->

    </div>            
</template>
 
<script>
    export default {
        data() {
            return {

                banners: [],

                filter_options: {
                    "mall": [],
                    "category": [],
                    "type": [],
                    "language": [],
                },

            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            }
        },
        components: {},
        beforeMount() {
            //window.addEventListener("resize", this.windowResizeEventHandler);
            window.addEventListener('scroll', this.handleScrollEvent);
        },
        beforeDestroy() {
            //window.removeEventListener("resize", this.windowResizeEventHandler);
            window.removeEventListener('scroll', this.handleScrollEvent);
        },
        created() {
            var app = this;
            //this.windowResizeEventHandler(null);
            this.checkIsEventFilterDisplay(); // only check once when init the page
            this.$root.SetEventFilterBtnPosition();
            this.$root.getCurrentPathName();
            this.info.loading = false;
            this.eventFilterResetClick();

            if (allBanner["home"]) this.banners = allBanner["home"];            
            this.$nextTick(function () {
                if (this.$refs.slide) {
                    $(this.$refs.slide).slick({
                        adaptiveHeight: true,
                        autoplay: true,
                        arrows: false,
                        dots: true
                    });
                }

                if (this.$refs.slide_resp) {
                    $(this.$refs.slide_resp).slick({
                        adaptiveHeight: true,
                        autoplay: true,
                        arrows: false,
                        dots: true
                    });
                }
            });

            // get filter options start
            app.$root.wsGet(app.info.wsUrl + "/Event/GetEventMall?filterEvent=true", app.$root.info.lang, function (data) {
                if (data.status == 0) {
                    app.filter_options.mall = data.mallList;
                    app.initFilterDataTagDivOverflow('filter_data_tag_div_1', app.filter_options.mall.length + 1);
                }
            });
            app.$root.wsGet(app.info.wsUrl + "/Event/GetEventCategory?filterEvent=true", app.$root.info.lang, function (data) {
                if (data.status == 0) {
                    app.filter_options.category = data.categoryList;
                    app.initFilterDataTagDivOverflow('filter_data_tag_div_2', app.filter_options.category.length + 1);
                }
            });
            app.$root.wsGet(app.info.wsUrl + "/Event/GetEventType?filterEvent=true", app.$root.info.lang, function (data) {
                if (data.status == 0) {
                    app.filter_options.type = data.typeList;
                    app.initFilterDataTagDivOverflow('filter_data_tag_div_3', app.filter_options.type.length + 1);
                }
            });
            app.$root.wsGet(app.info.wsUrl + "/Event/GetEventLanguage?filterEvent=true", app.$root.info.lang, function (data) {
                if (data.status == 0) {
                    app.filter_options.language = data.languageList;
                    app.initFilterDataTagDivOverflow('filter_data_tag_div_6', app.filter_options.language.length);
                }
            });
            // get filter options end

            // get event list start
            app.$root.activeScrollLoadEvent = true;

            //var eventFilter = app.$root.getParameterByName("eventFilter");
            var eventTitleFilter = app.$root.getParameterByName("eventTitle");            
            //if ((eventFilter != null && eventFilter != "") || (eventTitleFilter != null && eventTitleFilter != "")) {
            if (app.checkInitEventQueryFilter(false)) {
                app.initEventQueryFilter();
            }
            else {
                app.$root.GetEventList();
            }
            // get event list end

            // call NFGA
            var gathis = this;
            gathis.$root.NFGA_FillParam("NFGA_page_view");
        },
        destroyed() {
        },
        beforeDestroy() {
            if (this.$refs.slide) {
                $(this.$refs.slide).slick("unslick");
            }
            this.$root.activeScrollLoadEvent = false;
        },
        watch: {
            '$root.info.lang': function (lang) {
                this.initHomePageData();
                this.resetEventFilterDateDisplay();
            },
            '$root.info.member': function (member) {
                if (member == null) {
                    this.$root.ReloadCurrentPage();
                    //this.$router.push(`/` + this.info.lang + `/`);
                }
            }
        },
        mounted() {            
        },
        methods: {
            windowResizeEventHandler(e) {
                //this.checkIsEventFilterDisplay();
            },
            handleScrollEvent() {
                // load event when scroll
                this.$root.ScrollLoadEvent();     

                // fix filter btn
                this.$root.SetEventFilterBtnPosition();
            },
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            EventListDateDisplay(event) {
                return this.$root.writeDisplayDateFormat(event.eventStartDate) + (event.eventStartDate != event.eventEndDate ? " - " + this.$root.writeDisplayDateFormat(event.eventEndDate) : "")
            },

            initHomePageData() {
                var app = this;

                // get filter options start
                app.$root.wsGet(app.info.wsUrl + "/Event/GetEventMall?filterEvent=true", app.$root.info.lang, function (data) {
                    if (data.status == 0) {
                        app.filter_options.mall = data.mallList;
                    }
                });
                app.$root.wsGet(app.info.wsUrl + "/Event/GetEventCategory?filterEvent=true", app.$root.info.lang, function (data) {
                    if (data.status == 0) {
                        app.filter_options.category = data.categoryList;
                    }
                });
                app.$root.wsGet(app.info.wsUrl + "/Event/GetEventType?filterEvent=true", app.$root.info.lang, function (data) {
                    if (data.status == 0) {
                        app.filter_options.type = data.typeList;
                    }
                });
                app.$root.wsGet(app.info.wsUrl + "/Event/GetEventLanguage?filterEvent=true", app.$root.info.lang, function (data) {
                    if (data.status == 0) {
                        app.filter_options.language = data.languageList;
                    }
                });
                // get filter options end

                // get event list start
                app.$root.clearEventFilter();

                //var eventFilter = app.$root.getParameterByName("eventFilter");
                var eventTitleFilter = app.$root.getParameterByName("eventTitle");                
                //if ((eventFilter != null && eventFilter != "") || (eventTitleFilter != null && eventTitleFilter != "")) {
                if (app.checkInitEventQueryFilter(false)) {
                    app.initEventQueryFilter();
                }
                else {
                    app.$root.GetEventList();
                }
                // get event list end
            },

            // for event filter start
            checkIsEventFilterDisplay() {
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    this.$root.setBodyOverflow(false);
                    this.$root.info.showEventFilter = true;
                }
                else {
                    this.closeEventFilter();                    
                }
            },            
            eventFilterResetClick() {
                this.$root.filter_search = {
                    "mall": [],
                    "category": [],
                    "type": [],
                    "language": [],
                    "date": {
                        "filter_type": "",
                        "date_from": moment().format(this.$root.info.common_date_format),
                        "date_to": moment().format(this.$root.info.common_date_format),
                        "date_from_display": this.$root.writeDisplayDateFormat(moment()),
                        "date_to_display": this.$root.writeDisplayDateFormat(moment())
                    },
                    "price": -1,
                };
            },
            resetEventFilterDateDisplay() {
                this.$root.filter_search.date.date_from_display = this.$root.writeDisplayDateFormat(this.$root.filter_search.date.date_from);
                this.$root.filter_search.date.date_to_display = this.$root.writeDisplayDateFormat(this.$root.filter_search.date.date_to);
            },
            eventFilterSubmitClick() {
                var app = this;
                app.$root.clearEventFilter();
                app.$root.GetEventList(true);
                app.closeEventFilter();

                // scroll to event list top
                app.$root.GetHeaderHeight();
                var event_list_div_area = app.$el.querySelector("#event_list_div_area");
                var scroll_y = ($(event_list_div_area).offset().top - app.$root.header_div_info.height);                
                app.$root.scrollToXYAnimate({ "x": window.top.scrollX, "y": (scroll_y < 0 ? 0 : scroll_y) });
            },

            openEventFilter() {
                var window_size = window.innerWidth;
                if (window_size <= this.$root.info.responsive_width) {
                    this.$root.info.showEventFilter = true;
                    this.$root.setBodyOverflow(true);
                }
            },
            closeEventFilter() {
                var window_size = window.innerWidth;
                if (window_size <= this.$root.info.responsive_width) {
                    this.$root.info.showEventFilter = false;
                    this.$root.setBodyOverflow(false);
                }
            },
            eventFilterTagSelect(tagType, tagValue) {
                //console.log(tagType, tagValue);

                var app = this;
                var tagValueIdx = -1;
                switch (tagType) {
                    case "mall":
                        if (tagValue == "all") {
                            app.$root.filter_search.mall = [];
                        }
                        else {
                            tagValueIdx = app.$root.filter_search.mall.indexOf(tagValue);
                            if (tagValueIdx >= 0) {
                                app.$root.filter_search.mall.splice(tagValueIdx, 1);
                            }
                            else {
                                app.$root.filter_search.mall.push(tagValue);
                            }
                        }
                        break;

                    case "category":
                        if (tagValue == "all") {
                            app.$root.filter_search.category = [];
                        }
                        else {
                            tagValueIdx = app.$root.filter_search.category.indexOf(tagValue);
                            if (tagValueIdx >= 0) {
                                app.$root.filter_search.category.splice(tagValueIdx, 1);
                            }
                            else {
                                app.$root.filter_search.category.push(tagValue);
                            }
                        }
                        break;

                    case "type":
                        if (tagValue == "all") {
                            app.$root.filter_search.type = [];
                        }
                        else {
                            tagValueIdx = app.$root.filter_search.type.indexOf(tagValue);
                            if (tagValueIdx >= 0) {
                                app.$root.filter_search.type.splice(tagValueIdx, 1);
                            }
                            else {
                                app.$root.filter_search.type.push(tagValue);
                            }
                        }
                        break;

                    case "language":
                        if (tagValue == "all") {
                            app.$root.filter_search.language = [];
                        }
                        else {
                            tagValueIdx = app.$root.filter_search.language.indexOf(tagValue);
                            if (tagValueIdx >= 0) {
                                app.$root.filter_search.language.splice(tagValueIdx, 1);
                            }
                            else {
                                app.$root.filter_search.language.push(tagValue);
                            }
                        }
                        break;

                    case "price":
                        if (app.$root.filter_search.price == 0) {
                            app.$root.filter_search.price = -1;
                        }
                        else {
                            app.$root.filter_search.price = 0;
                        }
                        break;

                    case "date":
                        if (app.$root.filter_search.date.filter_type == tagValue) {
                            app.$root.filter_search.date.filter_type = "";
                        }
                        else {
                            app.$root.filter_search.date.filter_type = tagValue;
                        }   

                        if (tagValue == "today") {                                                     
                            app.$root.filter_search.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search.date.date_to = moment().format(this.$root.info.common_date_format);
                        }
                        else if (tagValue == "7days") {
                            app.$root.filter_search.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search.date.date_to = moment().add(7, 'days').format(this.$root.info.common_date_format);
                        }
                        else if (tagValue == "30days") {
                            app.$root.filter_search.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search.date.date_to = moment().add(30, 'days').format(this.$root.info.common_date_format);                            
                        }
                        else {
                        }
                        app.resetEventFilterDateDisplay();
                        break;


                    default:
                        break;
                }
            },
            eventFilterDatePickerOpen(type) {
                var app = this;
                app.$root.filter_search.date.filter_type = "range";
                if (app.$root.filter_search.date.filter_type == 'range') {

                    var fromObj = "#event_filter_date_from";
                    var toObj = "#event_filter_date_to";
                    var obj = toObj + "";
                    if (type == "from") {
                        obj = fromObj + "";
                    }

                    var fromDate = new Date();
                    var toDate = new Date();
                    if (type == "from") {
                        fromDate = new Date('2000/01/01');
                        toDate = new Date($(toObj).val());
                    }
                    else {
                        fromDate = new Date($(fromObj).val());
                        toDate = new Date(((new Date()).getFullYear() + 10)+"/12/31");
                    }

                    // datepicker start
                    $(obj).datepicker("destroy");
                    $(obj).datepicker({
                        monthNames: app.$root.datePicketLangSetup[app.$root.info.lang].monthNames,
                        dayNamesMin: app.$root.datePicketLangSetup[app.$root.info.lang].dayNamesMin,
                        showMonthAfterYear: app.$root.datePicketLangSetup[app.$root.info.lang].showMonthAfterYear,
                        yearSuffix: app.$root.datePicketLangSetup[app.$root.info.lang].yearSuffix,
                        dateFormat: "yy/mm/dd",
                        changeMonth: false,
                        changeYear: false,
                        minDate: fromDate,
                        maxDate: toDate,
                        beforeShowDay: function (date) {
                            var showDate = moment(date).format(app.$root.info.api_date_format);
                            if (type == "from") {
                                var highlight = (showDate == moment(app.$root.filter_search.date.date_from).format(app.$root.info.api_date_format));
                                if (highlight) {
                                    return [true, "selectDate", ""]; 
                                } else {
                                    return [true, "", ""];
                                }
                            }
                            else {
                                var highlight = (showDate == moment(app.$root.filter_search.date.date_to).format(app.$root.info.api_date_format));
                                if (highlight) {
                                    return [true, "selectDate", ""]; 
                                } else {
                                    return [true, "", ""];
                                }
                            }
                        },
                        onSelect: function (dateText, inst) {
                            var selectDate = moment(inst.currentYear + "/" + (inst.currentMonth + 1) + "/" + inst.currentDay);
                            //console.log(inst);
                            if (type == "from") {
                                //app.$root.filter_search.date.date_from = dateText;
                                app.$root.filter_search.date.date_from = selectDate.format(app.$root.info.common_date_format);        
                            }
                            else {
                                //app.$root.filter_search.date.date_to = dateText;
                                app.$root.filter_search.date.date_to = selectDate.format(app.$root.info.common_date_format);
                            }
                            app.resetEventFilterDateDisplay();
                        }
                    });
                    $(obj).datepicker("setDate", $(obj).val());
                    $(obj).datepicker("show");

                    // fix calendar position
                    if (window.innerWidth <= this.info.responsive_width) {
                        var filter_div = null;
                        if (type == "from") {
                            filter_div = $("#event_filter_date_from_div");
                        }
                        else {
                            filter_div = $("#event_filter_date_to_div");
                        }
                        //console.log("filter_div", filter_div.position());
                        $(".ui-datepicker.ui-widget.ui-widget-content").css({
                            "top": filter_div.position().top + "px"
                        });
                    }
                    // datepicker end
                }
            },                      

            checkFilterSearchDisplay() {
                if (this.$root.filter_search_current.mall.length > 0 ||
                    this.$root.filter_search_current.category.length > 0 ||
                    this.$root.filter_search_current.type.length > 0 ||
                    this.$root.filter_search_current.language.length > 0 ||
                    this.$root.filter_search_current.price >= 0 || 
                    this.$root.filter_search_current.date.filter_type != ""
                ) {
                    return true;
                }
                else {
                    return false;
                }
            },
            filterSearchTagDisplayText(tagType, tagValue) {
                var re = "";

                var app = this;
                switch (tagType) {
                    case "mall":
                        re = $(app.filter_options.mall).filter((i, o) => o["mallCode"] == tagValue)[0].mallName;
                        break;

                    case "category":
                        re = $(app.filter_options.category).filter((i, o) => o["categoryCode"] == tagValue)[0].categoryName;
                        break;

                    case "type":
                        re = $(app.filter_options.type).filter((i, o) => o["typeCode"] == tagValue)[0].typeName;
                        break;

                    case "language":
                        re = $(app.filter_options.language).filter((i, o) => o["languageCode"] == tagValue)[0].languageName;
                        break;

                    case "price":
                        if (tagValue == 0) {
                            re = app.label['home_event_filter_text_Price_FreeOfCharge'];
                        }
                        break;

                    case "date":                  
                        if (tagValue == "today") {
                            re = app.label['home_event_filter_text_Date_today'];
                        }
                        else if (tagValue == "7days") {
                            re = app.label['home_event_filter_text_Date_Next7days'];
                        }
                        else if (tagValue == "30days") {
                            re = app.label['home_event_filter_text_Date_Next30days'];
                        }
                        else if (tagValue == "range") {
                            re = app.$root.filter_search_current.date.date_from_display + " - " + app.$root.filter_search_current.date.date_to_display;
                        }
                        break;


                    default:
                        break;
                }

                return re;
            },
            filterSearchTagRemove(tagType, tagValue) {
                this.eventFilterTagSelect(tagType, tagValue);
                this.eventFilterSubmitClick();
            },
            checkInitEventQueryFilter(getFilter) {
                var app = this;
                var isSearch = false;

                /*
                var eventFilter = app.$root.getParameterByName("eventFilter");
                if (eventFilter != null && eventFilter != "") {
                    $.extend(app.$root.filter_search, JSON.parse(eventFilter));
                    $.extend(app.$root.filter_search_current, JSON.parse(eventFilter));
                    isSearch = true;
                }
                */

                var mallFilter = app.$root.getParameterByName("mall");
                if (mallFilter != null && mallFilter != "") {
                    if (getFilter) {
                        app.$root.filter_search["mall"] = mallFilter.split(',');
                        app.$root.filter_search_current["mall"] = mallFilter.split(',');
                    }
                    isSearch = true;
                }

                var categoryFilter = app.$root.getParameterByName("category");
                if (categoryFilter != null && categoryFilter != "") {
                    if (getFilter) {
                        app.$root.filter_search["category"] = categoryFilter.split(',');
                        app.$root.filter_search_current["category"] = categoryFilter.split(',');
                    }
                    isSearch = true;
                }

                var typeFilter = app.$root.getParameterByName("type");
                if (typeFilter != null && typeFilter != "") {
                    if (getFilter) {
                        app.$root.filter_search["type"] = typeFilter.split(',');
                        app.$root.filter_search_current["type"] = typeFilter.split(',');
                    }
                    isSearch = true;
                }

                var languageFilter = app.$root.getParameterByName("language");
                if (languageFilter != null && languageFilter != "") {
                    if (getFilter) {
                        app.$root.filter_search["language"] = languageFilter.split(',');
                        app.$root.filter_search_current["language"] = languageFilter.split(',');
                    }
                    isSearch = true;
                }

                var priceFilter = app.$root.getParameterByName("price");
                if (priceFilter != null && priceFilter != "") {
                    if (getFilter) {
                        app.$root.filter_search["price"] = parseInt(priceFilter, 10);
                        app.$root.filter_search_current["price"] = parseInt(priceFilter, 10);
                    }
                    isSearch = true;
                }

                var dateTypeFilter = app.$root.getParameterByName("dateType");
                if (dateTypeFilter != null && dateTypeFilter != "") {
                    if (getFilter) {
                        app.$root.filter_search["date"]["filter_type"] = dateTypeFilter;
                        app.$root.filter_search_current["date"]["filter_type"] = dateTypeFilter;

                        if (dateTypeFilter == "today") {
                            app.$root.filter_search.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search.date.date_to = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search_current.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search_current.date.date_to = moment().format(this.$root.info.common_date_format);
                        }
                        else if (dateTypeFilter == "7days") {
                            app.$root.filter_search.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search.date.date_to = moment().add(7, 'days').format(this.$root.info.common_date_format);
                            app.$root.filter_search_current.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search_current.date.date_to = moment().add(7, 'days').format(this.$root.info.common_date_format);
                        }
                        else if (dateTypeFilter == "30days") {
                            app.$root.filter_search.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search.date.date_to = moment().add(30, 'days').format(this.$root.info.common_date_format);
                            app.$root.filter_search_current.date.date_from = moment().format(this.$root.info.common_date_format);
                            app.$root.filter_search_current.date.date_to = moment().add(30, 'days').format(this.$root.info.common_date_format);
                        }
                        else if (dateTypeFilter == "range") {
                            var dateTypeFromFilter = app.$root.getParameterByName("dateTypeFrom");
                            var dateTypeToFilter = app.$root.getParameterByName("dateTypeTo");
                            if ((dateTypeFromFilter != null && dateTypeFromFilter != "") && (dateTypeToFilter != null && dateTypeToFilter != "")) {
                                app.$root.filter_search.date.date_from = moment(dateTypeFromFilter);
                                app.$root.filter_search.date.date_to = moment(dateTypeToFilter);
                                app.$root.filter_search_current.date.date_from = moment(dateTypeFromFilter);
                                app.$root.filter_search_current.date.date_to = moment(dateTypeToFilter);
                                app.$root.filter_search.date.date_from_display = app.$root.writeDisplayDateFormat(app.$root.filter_search.date.date_from);
                                app.$root.filter_search.date.date_to_display = app.$root.writeDisplayDateFormat(app.$root.filter_search.date.date_to);
                                app.$root.filter_search_current.date.date_from_display = app.$root.writeDisplayDateFormat(app.$root.filter_search_current.date.date_from);
                                app.$root.filter_search_current.date.date_to_display = app.$root.writeDisplayDateFormat(app.$root.filter_search_current.date.date_to);
                            }
                        }
                        else {
                        }
                    }
                    isSearch = true;
                }

                var eventTitle = app.$root.getParameterByName("eventTitle");
                if (eventTitle != null && eventTitle != "") {
                    if (getFilter) {
                        app.$root.eventTitleFilter.searchText = eventTitle;
                        app.$root.eventTitleFilter.searchTextCurrent = eventTitle;
                    }
                    isSearch = true;
                }

                return isSearch;
            },
            initEventQueryFilter() {
                var app = this;
                if (app.filter_options.mall.length > 0 && app.filter_options.category.length > 0 && app.filter_options.type.length > 0 && app.filter_options.language.length > 0) {
                    var isSearch = false;

                    isSearch = app.checkInitEventQueryFilter(true);

                    if (isSearch) {
                        app.$root.GetEventList();
                    }
                }
                else {
                    window.setTimeout(function () { app.initEventQueryFilter(); }, 500);
                }
            },
            // for event filter end

            // for tag_filter_div_arrow start
            initFilterDataTagDivOverflow(filter_data_tag_div_id, option_length) {
                var app = this;
                if (window.innerWidth > app.info.responsive_width) {

                    var filter_data_tag_div = app.$refs[filter_data_tag_div_id];
                    if (filter_data_tag_div != undefined) {
                        var tag_filter_div = $(filter_data_tag_div).find(".tag_filter_div")[0];
                        var option_filter = $(tag_filter_div).find(".option_filter")[0];
                        var option_tag = $(option_filter).find(".option_tag");

                        if (option_tag.length == option_length) {
                            //console.log("filter_data_tag_div_id", filter_data_tag_div_id);
                            //console.log("tag_filter_div", tag_filter_div);
                            //console.log("tag_filter_div.offsetHeight", tag_filter_div.offsetHeight);
                            //console.log("tag_filter_div.scrollHeight", tag_filter_div.scrollHeight);
                            //console.log("option_filter.offsetHeight", option_filter.offsetHeight);

                            if (tag_filter_div.offsetHeight < option_filter.offsetHeight) {
                                var tag_filter_div_arrow_div = $(filter_data_tag_div).find(".tag_filter_div_arrow_div");
                                tag_filter_div_arrow_div.show();
                            }
                        }
                        else {
                            window.setTimeout(function () { app.initFilterDataTagDivOverflow(filter_data_tag_div_id, option_length); }, 200);
                        }
                    }

                }
            },
            TagFilterArrowClick(event, action) {
                var arrow_div = $(event.target);
                var tag_filter_div_arrow_div = arrow_div.parent();
                var filter_data_tag_div = arrow_div.parents(".filter_data_tag_div");
                var tag_filter_div = $(filter_data_tag_div).find(".tag_filter_div")[0];
                var option_filter = $(tag_filter_div).find(".option_filter")[0];

                if (action == "down") {
                    $(tag_filter_div).animate({ scrollTop: (option_filter.offsetHeight) }, 200,
                        function () {
                            tag_filter_div_arrow_div.removeClass("down").addClass("up");
                        }
                    );
                }
                else if (action == "up") {
                    $(tag_filter_div).animate({ scrollTop: (0) }, 200,
                        function () {
                            tag_filter_div_arrow_div.removeClass("up").addClass("down");
                        }
                    );
                }                
            },
            // for tag_filter_div_arrow end

        }
    }; // export default end
</script>
